import apiClient from 'services/api/apiService';
import { getUrlWithQueryParams } from 'services/api/getUrlWithQueryParams';
import {
  ICreateTemplateData,
  ITemplate,
  ITemplatesResponse,
  IUpdateTemplateData,
  TemplateVisibility,
} from 'types/Template.types';

const BASE_URL = '/v1/templates';

export const getTemplates = async (
  modelId: number,
  page: number,
  perPage: number,
  searchTerm: string,
  visibility?: TemplateVisibility
): Promise<ITemplatesResponse> => {
  const queryParamsObj = {
    model_id: modelId,
    page: page,
    per_page: perPage,
    search_term: searchTerm,
    visibility: visibility,
  };
  const fullUrl = getUrlWithQueryParams(BASE_URL, queryParamsObj);
  const { data } = await apiClient.get<any>(fullUrl);

  return data.data;
};

export const createTemplate = async (
  createTemplateData: ICreateTemplateData
): Promise<ITemplate> => {
  const { data } = await apiClient.post<any>(BASE_URL, createTemplateData);

  return data.data;
};

export const getSingleTemplate = async (
  templateId: number
): Promise<ITemplate> => {
  const { data } = await apiClient.get<any>(`${BASE_URL}/${templateId}`);

  return data.data;
};

export const updateTemplate = async (
  templateId: number,
  updateTemplateData: IUpdateTemplateData
): Promise<ITemplate> => {
  const { data } = await apiClient.patch<any>(
    `${BASE_URL}/${templateId}`,
    updateTemplateData
  );

  return data.data;
};

export const deleteTemplate = async (templateId: number): Promise<any> => {
  const { data } = await apiClient.delete<any>(`${BASE_URL}/${templateId}`);

  return data.data;
};
